import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import authConfig from "./authConfig";
import axios from "axios";

axios.defaults.headers.common["x-api-key"] = process.env.REACT_APP_API_KEY;

const pca = new PublicClientApplication(authConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <MsalProvider instance={pca}>
    <Provider store={store}>
      <App />
    </Provider>
  </MsalProvider>
  // </React.StrictMode>
);
